import * as tslib_1 from "tslib";
import { extend, getGUID, sanitizeGuid, stringIsNullOrEmpty } from "@pnp/common";
import { ClientSvcQueryable, MethodParams, setProperty } from "@pnp/sp-clientsvc";
import { TermGroup } from "./termgroup";
import { Term, Terms } from "./terms";
var TermSets = /** @class */ (function (_super) {
    tslib_1.__extends(TermSets, _super);
    function TermSets() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Gets the termsets in this collection
     */
    TermSets.prototype.get = function () {
        var _this = this;
        return this.sendGetCollection(function (d) {
            if (!stringIsNullOrEmpty(d.Name)) {
                return _this.getByName(d.Name);
            }
            else if (!stringIsNullOrEmpty(d.Id)) {
                return _this.getById(d.Id);
            }
            throw Error("Could not find Value in Labels.get(). You must include at least one of these in your select fields.");
        });
    };
    /**
     * Gets a TermSet from this collection by id
     *
     * @param id TermSet id
     */
    TermSets.prototype.getById = function (id) {
        var params = MethodParams.build()
            .string(sanitizeGuid(id));
        return this.getChild(TermSet, "GetById", params);
    };
    /**
     * Gets a TermSet from this collection by name
     *
     * @param name TermSet name
     */
    TermSets.prototype.getByName = function (name) {
        var params = MethodParams.build()
            .string(name);
        return this.getChild(TermSet, "GetByName", params);
    };
    return TermSets;
}(ClientSvcQueryable));
export { TermSets };
var TermSet = /** @class */ (function (_super) {
    tslib_1.__extends(TermSet, _super);
    function TermSet() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(TermSet.prototype, "group", {
        /**
         * Gets the group containing this Term set
         */
        get: function () {
            return this.getChildProperty(TermGroup, "Group");
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TermSet.prototype, "terms", {
        /**
         * Access all the terms in this termset
         */
        get: function () {
            return this.getChild(Terms, "GetAllTerms", null);
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Adds a stakeholder to the TermSet
     *
     * @param stakeholderName The login name of the user to be added as a stakeholder
     */
    TermSet.prototype.addStakeholder = function (stakeholderName) {
        var params = MethodParams.build()
            .string(stakeholderName);
        return this.invokeNonQuery("DeleteStakeholder", params);
    };
    /**
     * Deletes a stakeholder to the TermSet
     *
     * @param stakeholderName The login name of the user to be added as a stakeholder
     */
    TermSet.prototype.deleteStakeholder = function (stakeholderName) {
        var params = MethodParams.build()
            .string(stakeholderName);
        return this.invokeNonQuery("AddStakeholder", params);
    };
    /**
     * Gets the data for this TermSet
     */
    TermSet.prototype.get = function () {
        return this.sendGet(TermSet);
    };
    /**
     * Get a term by id
     *
     * @param id Term id
     */
    TermSet.prototype.getTermById = function (id) {
        var params = MethodParams.build()
            .string(sanitizeGuid(id));
        return this.getChild(Term, "GetTerm", params);
    };
    /**
     * Adds a term to this term set
     *
     * @param name Name for the term
     * @param lcid Language code
     * @param isAvailableForTagging set tagging availability (default: true)
     * @param id GUID id for the term (optional)
     */
    TermSet.prototype.addTerm = function (name, lcid, isAvailableForTagging, id) {
        var _this = this;
        if (isAvailableForTagging === void 0) { isAvailableForTagging = true; }
        if (id === void 0) { id = getGUID(); }
        var params = MethodParams.build()
            .string(name)
            .number(lcid)
            .string(sanitizeGuid(id));
        this._useCaching = false;
        return this.invokeMethod("CreateTerm", params, setProperty("IsAvailableForTagging", "Boolean", "" + isAvailableForTagging))
            .then(function (r) { return extend(_this.getTermById(r.Id), r); });
    };
    /**
     * Copies this term set immediately
     */
    TermSet.prototype.copy = function () {
        return this.invokeMethod("Copy", null);
    };
    /**
     * Updates the specified properties of this term set, not all properties can be updated
     *
     * @param properties Plain object representing the properties and new values to update
     */
    TermSet.prototype.update = function (properties) {
        return this.invokeUpdate(properties, TermSet);
    };
    return TermSet;
}(ClientSvcQueryable));
export { TermSet };
//# sourceMappingURL=termsets.js.map